interface ClientHealthBadgeProps {
  score: number;
  status: "healthy" | "neutral" | "at_risk" | "critical";
  delta7d?: number | null;
  size?: "sm" | "md";
}

const statusColors: Record<string, string> = {
  healthy: "bg-green-500",
  neutral: "bg-yellow-500",
  at_risk: "bg-orange-500",
  critical: "bg-red-500",
};

const statusLabels: Record<string, string> = {
  healthy: "Healthy",
  neutral: "Neutral",
  at_risk: "At Risk",
  critical: "Critical",
};

export default function ClientHealthBadge({
  score,
  status,
  delta7d,
  size = "md",
}: ClientHealthBadgeProps) {
  const dotSize = size === "sm" ? "w-2 h-2" : "w-2.5 h-2.5";
  const textSize = size === "sm" ? "text-xs" : "text-sm";

  return (
    <div className={`flex items-center gap-1.5 ${textSize}`}>
      <div className={`${dotSize} rounded-full ${statusColors[status]}`} />
      <span className="font-bold">{score}</span>
      <span className="text-muted-foreground">{statusLabels[status]}</span>
      {delta7d != null && delta7d !== 0 && (
        <span className={delta7d > 0 ? "text-green-600" : "text-red-600"}>
          {delta7d > 0 ? `↑${delta7d}` : `↓${Math.abs(delta7d)}`}
        </span>
      )}
    </div>
  );
}
